import styled from 'styled-components';
import { withRouter } from 'react-router'

import AnnouncementsTable from './components/AnnouncementsTable';

function AnnouncementsPage() {
  return (<AnnouncementsContainer>
    <AnnouncementsTable />
  </AnnouncementsContainer>);
}

export default withRouter(AnnouncementsPage);

const AnnouncementsContainer = styled.div`
  margin: 16px 0;
  background-color: #FFFFFF;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
  padding: 2rem;
`;
